export default "__VITE_ASSET__BNTcaPh4__"